import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Badge, IconButton, Tooltip } from '@material-ui/core';
import Zoom from '@material-ui/core/Zoom';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: 15,
    '& span.MuiBadge-badge': {
      marginRight: -4,
      marginTop: -2,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
    '&.selected .MuiSvgIcon-root': {
      fill: theme.palette.primary.dark,
    },
    '&:hover .MuiSvgIcon-root': {
      fill: theme.palette.primary.main,
    },
    '&:hover span.MuiBadge-badge': {
      color: theme.palette.primary.main,
      backgroundColor: `${theme.palette.primary.main}30`,
    },
  },

}));

export const IconButtonUI = ({
  children,
  title = '',
  handleClick,
  badgeContent,
  disabled,
  selected,
  Icon = ErrorIcon,
  size,
  placement = 'bottom',
  iconColor = 'inherit',
}) => {
  const classes = useStyles();
  const [tooltipActive, setTooltipActive] = useState(false);

  const iconCustomStyle = { fontSize: size || 'inherit' };
  const iconButtonClass = `${classes.button}${selected ? ' selected' : ''}`;

  const handleShowTooltip = () => { if (!disabled) setTooltipActive(true); };
  const handleHideTooltip = () => setTooltipActive(false);

  const badgeColor = disabled ? 'secondary' : 'primary';

  return (
    <Tooltip
      arrow
      title={title}
      TransitionComponent={Zoom}
      placement={placement}
      open={tooltipActive && !disabled}
      onOpen={handleShowTooltip}
      onClose={handleHideTooltip}
    >
      <span className="icon-wrapper">
        <IconButton className={iconButtonClass} disabled={disabled} onClick={handleClick}>
          <Badge badgeContent={badgeContent} overlap="rectangular" color={badgeColor}>
            <Icon fontSize="medium" style={iconCustomStyle} color={iconColor} />
          </Badge>
        </IconButton>
        { children }
      </span>
    </Tooltip>
  );
};

export default IconButtonUI;
